import { X } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface TopBannerProps {
  onClose: () => void;
}

export default function TopBanner({ onClose }: TopBannerProps) {
  const { t } = useTranslation();

  return (
    <div className="fixed top-0 left-0 w-full z-50 bg-[#007a33] h-14 px-4 sm:px-6 md:px-8">
      <div className="flex items-center justify-between max-w-6xl h-full mx-auto relative gap-2">
        <div className="flex flex-col sm:flex-row items-center justify-center w-full gap-2 sm:gap-4 text-center sm:text-left">
          <p className="text-xs sm:text-sm md:text-base font-medium text-white">
            {t('topBanner.exposed_info')}
          </p>
          <Link
            to="/scan"
            className="bg-white text-green-800 px-4 py-1.5 rounded-full font-semibold 
                       hover:bg-gray-200 transition-all text-xs sm:text-sm md:text-base"
          >
            {t('topBanner.scan_now')}
          </Link>
        </div>
        <button
          onClick={onClose}
          className="absolute right-4 top-1/2 -translate-y-1/2 text-white hover:text-gray-200 transition-all"
        >
          <X className="h-4 w-4 sm:h-5 sm:w-5 md:h-6 md:w-6" />
        </button>
      </div>
    </div>
  );
}
